import React, { useEffect, useState } from "react";
import ReactMarkdown from "react-markdown";

type LegalType = "privacy" | "terms" | "cookies";

const FILE_MAP: Record<LegalType, () => Promise<{ default: string }>> = {
  privacy: () => import("../content/Legal/privacy.md"),
  terms: () => import("../content/Legal/terms.md"),
  cookies: () => import("../content/Legal/cookies.md"),
};

const LegalPage: React.FC<{ type: LegalType; title: string }> = ({ type, title }) => {
  const [content, setContent] = useState("");

  useEffect(() => {
    FILE_MAP[type]()
      .then((mod) => fetch(mod.default))
      .then((res) => res.text())
      .then(setContent)
      .catch(() => setContent(""));

  }, [type]);

  return (
    <main className="legal-page">
      <h1>{title}</h1>
      <ReactMarkdown>{content}</ReactMarkdown>
    </main>
  );
};

export default LegalPage;